
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './presentation/modules/landing/HomePage';
import { TenantProvider } from './context/TenantContext';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import MedidoresPage from './presentation/modules/medidores/MedidoresPage';
import ClientesPage from './presentation/modules/clientes/ClientesPage';
import ConsumosPage from './presentation/modules/consumos/ConsumosPage';
import Tarifas from './presentation/modules/tarifas/TarifasPage';
import Reportes from './presentation/modules/reportes/ReportesPage';
import RendicionPage from './presentation/modules/rendicion/RendicionPage';
import PerfilPage from './presentation/modules/perfil/PerfilPage';
import MiEmpresaPage from './presentation/modules/junta/MiEmpresaPage';
import PrivacidadPage from './presentation/modules/public/PrivacidadPage';
import ProtectedRoute from './presentation/modules/auth/ProtectedRoute';
import DashboardHome from './presentation/modules/dashboard/DashboardHome';
import EmpresasList from './presentation/modules/empresas/EmpresasList';
import UsuariosList from './presentation/modules/users/UsuariosList';
import PagosPage from './presentation/modules/pagos/PagosPage';
import DeudasPage from './presentation/modules/deudas/DeudasPage';
import DashboardLayout from './presentation/layouts/DashboardLayout';
import './App.css';

const App = () => {
  return (
    <TenantProvider>
      <AuthProvider>
        <ToastProvider>
          <Router>
            <Routes>
              {/* Rutas Públicas - TODO EN UNA SOLA PÁGINA */}
              <Route path="/" element={<HomePage />} />
              <Route path="/privacidad" element={<PrivacidadPage />} />

              {/* Rutas Admin */}
              <Route path="/admin">
                <Route path="dashboard" element={<ProtectedRoute allowedRoles={[]}><DashboardHome /></ProtectedRoute>} />
                <Route path="empresas" element={<ProtectedRoute allowedRoles={[]} checkSuperAdmin={true}><EmpresasList /></ProtectedRoute>} />
                <Route path="usuarios" element={<ProtectedRoute allowedRoles={[]}><DashboardLayout title="Usuarios"><UsuariosList /></DashboardLayout></ProtectedRoute>} />
                <Route path="tarifas" element={<ProtectedRoute allowedRoles={[]}><Tarifas /></ProtectedRoute>} />
                <Route path="medidores" element={<ProtectedRoute allowedRoles={[]}><MedidoresPage /></ProtectedRoute>} />
                <Route path="clientes" element={<ProtectedRoute allowedRoles={[]}><ClientesPage /></ProtectedRoute>} />
                <Route path="consumos" element={<ProtectedRoute allowedRoles={[]}><ConsumosPage /></ProtectedRoute>} />
                <Route path="pagos" element={<ProtectedRoute allowedRoles={[]}><PagosPage /></ProtectedRoute>} />
                <Route path="deudas" element={<ProtectedRoute allowedRoles={[]}><DeudasPage /></ProtectedRoute>} />
                <Route path="rendicioncuentas" element={<ProtectedRoute allowedRoles={[]}><RendicionPage /></ProtectedRoute>} />
                <Route path="perfil" element={<ProtectedRoute allowedRoles={[]}><PerfilPage /></ProtectedRoute>} />
                <Route path="mi-empresa" element={<ProtectedRoute allowedRoles={['A', 'Administrador', 'Presidente', 'Secretario', 'R', 'Super Admin']}><MiEmpresaPage /></ProtectedRoute>} />
                <Route path="reportes" element={<ProtectedRoute allowedRoles={[]}><Reportes /></ProtectedRoute>} />
              </Route>
            </Routes>
          </Router>
        </ToastProvider>
      </AuthProvider>
    </TenantProvider>
  );
};

export default App;
